(function () {
  'use strict';
  var showUpsellPopup; // declarado aquí para que bindAtcForm pueda referenciarlo

  /* ── ANNOUNCEMENT BAR ── */
  var annMsgs = [
    '🎁 <span class="ann-pill">CÓDIGO: VERANO10</span> <strong>10% DE DESCUENTO</strong> · 🚚 Envío GRATIS · Úsalo al pagar',
  ];
  var annIdx = 0;
  var annEl = document.getElementById('annText');
  function setAnn(i) {
    if (!annEl) return;
    annIdx = ((i % annMsgs.length) + annMsgs.length) % annMsgs.length;
    annEl.style.opacity = '0';
    setTimeout(function () {
      annEl.innerHTML = annMsgs[annIdx];
      annEl.style.transition = 'opacity .4s';
      annEl.style.opacity = '1';
    }, 200);
  }
  setAnn(0);
  setInterval(function () { setAnn(annIdx + 1); }, 4000);
  var prev = document.getElementById('annPrev');
  var next = document.getElementById('annNext');
  if (prev) prev.addEventListener('click', function () { setAnn(annIdx - 1); });
  if (next) next.addEventListener('click', function () { setAnn(annIdx + 1); });

  /* ── NAV SCROLL ── */
  var nav = document.getElementById('mainNav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ── MOBILE MENU ── */
  var hamburger = document.getElementById('hamburger');
  var navMobile = document.getElementById('navMobile');
  var navClose = document.getElementById('navClose');
  function openMobile() {
    navMobile && navMobile.classList.add('is-open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobile() {
    navMobile && navMobile.classList.remove('is-open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', openMobile);
  if (navClose) navClose.addEventListener('click', closeMobile);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMobile(); closeCart(); } });

  /* ── CART STATE ── */
  var cartData = { items: [], total: 0 };

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cartData = data;
        updateCartUI();
        return data;
      })
      .catch(function () {});
  }

  function updateCartUI() {
    var count = cartData.item_count || 0;
    var navCount = document.getElementById('navCartCount');
    var drawerCount = document.getElementById('drawerCount');
    if (navCount) {
      navCount.textContent = count;
      navCount.style.display = count > 0 ? 'flex' : 'none';
    }
    if (drawerCount) drawerCount.textContent = count;

    var total = cartData.total_price || 0;
    var totalEl = document.getElementById('cartTotal');
    if (totalEl) totalEl.textContent = formatMoney(total);

    var origTotal = document.getElementById('cartOrigTotal');
    var savings = document.getElementById('cartSavings');
    var origPrice = cartData.original_total_price || total;
    if (origTotal) {
      if (origPrice > total) {
        origTotal.textContent = formatMoney(origPrice);
        if (savings) savings.textContent = '−' + formatMoney(origPrice - total);
      } else {
        origTotal.textContent = '';
        if (savings) savings.textContent = '';
      }
    }

    renderCartItems();
  }

  function renderCartItems() {
    var container = document.getElementById('cartItems');
    if (!container) return;
    var items = cartData.items || [];
    if (!items.length) {
      container.innerHTML = '<div class="cart-empty-msg">Tu carrito está vacío.</div>';
      return;
    }
    container.innerHTML = items.map(function (item) {
      return '<div class="cart-item">' +
        (item.featured_image && item.featured_image.url
          ? '<img class="cart-item-img" src="' + item.featured_image.url + '" alt="' + escHtml(item.title) + '">'
          : '<div class="cart-item-img" style="background:var(--sand-dark)"></div>') +
        '<div class="cart-item-info">' +
          '<div class="cart-item-title">' + escHtml(item.product_title) + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item-variant">' + escHtml(item.variant_title) + '</div>' : '') +
          '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cart-item-qty">' +
            '<button class="cart-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
            '<span class="cart-qty-num">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    container.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-key');
        var qty = parseInt(this.getAttribute('data-qty'), 10);
        updateQty(key, qty);
      });
    });
  }

  function updateQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (data) { cartData = data; updateCartUI(); })
      .catch(function () {});
  }

  /* ── CART DRAWER ── */
  var cartOverlay = document.getElementById('cartOverlay');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartClose = document.getElementById('cartClose');
  var navCartBtn = document.getElementById('navCartBtn');

  function openCart() {
    fetchCart().then(function () {
      cartDrawer && cartDrawer.classList.add('is-open');
      cartOverlay && cartOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (navCartBtn) {
    navCartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ── ADD TO CART (from product form) ── */
  var _atcBusy = false; // candado anti doble-añadido (doble-clic / doble evento)
  function addToCart(variantId, quantity, btn, orig, properties) {
    if (_atcBusy) { return; } // ya hay un añadido en curso → ignora el segundo
    var id = parseInt(variantId, 10);
    if (!id) { console.error('[ATC] ID inválido:', variantId); if (btn) { btn.innerHTML = orig; btn.disabled = false; } return; }

    _atcBusy = true;
    var _payload = { id: id, quantity: quantity };
    if (properties && Object.keys(properties).length) _payload.properties = properties;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(_payload)
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) { throw new Error(err.description || err.message || 'Error ' + r.status); });
      }
      return r.json();
    })
    .then(function () {
      return fetchCart();
    })
    .then(function () {
      _atcBusy = false;
      openCart();
      if (btn) {
        btn.innerHTML = '✓ Añadido';
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 2000);
      }
    })
    .catch(function (err) {
      _atcBusy = false;
      console.error('[ATC] Error:', err && err.message);
      if (btn) { btn.innerHTML = orig; btn.disabled = false; }
      alert('No se pudo añadir al carrito. Por favor recarga la página e inténtalo de nuevo.');
    });
  }

  function bindAtcForm(form) {
    if (!form) return;
    if (form.__atcBound) return; // evita doble enganche del mismo formulario
    form.__atcBound = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var variantId = fd.get('id');
      var quantity  = parseInt(fd.get('quantity') || '1', 10);
      var btn  = form.querySelector('[type=submit]');
      var orig = btn ? btn.innerHTML : '';
      // Mostrar upsell si el pack ×1 está activo
      var singleActive = document.querySelector('.kv-bopt[data-type="single"].kv-bopt-active');
      if (singleActive && showUpsellPopup) {
        showUpsellPopup(variantId, quantity, btn, orig);
        return;
      }
      // Recoger los colores elegidos del pack (line item properties)
      var properties = {};
      var bundleActive = document.querySelector('.kv-bopt[data-type="bundle"].kv-bopt-active');
      var packColors = document.getElementById('kvPackColors');
      if (bundleActive && packColors) {
        packColors.querySelectorAll('select').forEach(function (sel) {
          if (sel.dataset.prop && sel.value) properties[sel.dataset.prop] = sel.value;
        });
      }
      if (btn) { btn.innerHTML = '<span>Añadiendo...</span>'; btn.disabled = true; }
      addToCart(variantId, quantity, btn, orig, properties);
    });
  }

  document.querySelectorAll('form[action="/cart/add"]').forEach(bindAtcForm);
  // Formulario de compra del homepage (no tiene action=/cart/add)
  var kvHpForm = document.getElementById('kvAddForm');
  if (kvHpForm) bindAtcForm(kvHpForm);

  /* ── COLOR SWATCHES (homepage showcase + product page) ── */
  document.querySelectorAll('.color-swatch, .product-swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var group = this.closest('.color-swatches, .product-color-swatches');
      if (group) group.querySelectorAll('.color-swatch, .product-swatch').forEach(function (s) { s.classList.remove('active'); });
      this.classList.add('active');
      var color = this.getAttribute('data-color');
      var label = this.closest('.showcase-info, .product-info');
      if (label) {
        var colorLabelEl = label.querySelector('.color-label, .product-variant-label');
        if (colorLabelEl) {
          var names = { gray: 'Gris', black: 'Negro', beige: 'Beige', navy: 'Azul marino' };
          colorLabelEl.textContent = 'Color: ' + (names[color] || color);
        }
      }
      // Sync variant select if present
      var variantSelect = document.querySelector('select[name="id"]');
      if (variantSelect) {
        var opt = variantSelect.querySelector('option[data-color="' + color + '"]');
        if (opt) variantSelect.value = opt.value;
      }
    });
  });

  /* ── PRODUCT GALLERY (imágenes + vídeos + TikTok) ── */
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');

      var mediaType = this.getAttribute('data-media-type');
      var wrap = document.getElementById('mainImgWrap');
      if (!wrap) return;

      if (mediaType === 'tiktok') {
        var tiktokId = this.getAttribute('data-tiktok-id');
        wrap.innerHTML = '<iframe src="https://www.tiktok.com/embed/v2/' + tiktokId + '" frameborder="0" allow="autoplay" allowfullscreen scrolling="no" style="width:100%;height:100%;border:none;display:block"></iframe>';
      } else if (mediaType === 'video') {
        var videoSrc = this.getAttribute('data-video-src');
        var existing = wrap.querySelector('video');
        if (existing) { existing.src = videoSrc; existing.load(); existing.play(); return; }
        wrap.innerHTML = '<video autoplay muted loop playsinline style="width:100%;height:100%;object-fit:cover"><source src="' + videoSrc + '"></video>';
      } else {
        var src = this.getAttribute('data-src');
        var existingVideo = wrap.querySelector('video');
        var existingIframe = wrap.querySelector('iframe');
        if (existingVideo || existingIframe) {
          if (existingVideo) existingVideo.pause();
          wrap.innerHTML = '<img id="mainImg" src="' + src + '" alt="producto" style="width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .3s">';
          setTimeout(function() { var img = wrap.querySelector('img'); if(img) img.style.opacity='1'; }, 50);
          return;
        }
        var mainImg = wrap.querySelector('img');
        if (mainImg && src) {
          mainImg.style.opacity = '0';
          setTimeout(function () { mainImg.src = src; mainImg.style.opacity = '1'; }, 200);
        }
      }
    });
  });

  /* ── COUNTDOWN TIMER (urgency bar) ── */
  function initCountdown() {
    var stored = localStorage.getItem('kv_countdown_end');
    var end;
    if (stored) {
      end = parseInt(stored, 10);
      if (isNaN(end) || end < Date.now()) {
        end = Date.now() + 8 * 3600 * 1000;
        localStorage.setItem('kv_countdown_end', end);
      }
    } else {
      end = Date.now() + 8 * 3600 * 1000;
      localStorage.setItem('kv_countdown_end', end);
    }

    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = document.getElementById('cdHours');
      var mEl = document.getElementById('cdMins');
      var sEl = document.getElementById('cdSecs');
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }
  initCountdown();

  /* ── SCROLL ANIMATIONS ── */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.problem-card, .feature-card, .review-card, .step-card').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity .5s, transform .5s';
    observer.observe(el);
  });

  // Add .visible CSS rule inline (simpler than stylesheet)
  var style = document.createElement('style');
  style.textContent = '.visible { opacity: 1 !important; transform: none !important; }';
  document.head.appendChild(style);

  /* ── UTILITIES ── */
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function escHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ── STOCK COUNTER ── */
  var stockKey = 'kv_stock_val';
  var storedStock = localStorage.getItem(stockKey);
  var stock = storedStock ? parseInt(storedStock, 10) : (6 + Math.floor(Math.random() * 5));
  localStorage.setItem(stockKey, stock);
  function updateStockEls() {
    ['kvStock','kvStock2','kvUrgencyStock'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = stock;
    });
    var bar = document.getElementById('kvStockBar');
    if (bar) {
      var pct = Math.min(95, Math.max(40, 100 - (stock / 12) * 60));
      bar.style.width = pct + '%';
    }
  }
  updateStockEls();
  setInterval(function () {
    if (stock > 3 && Math.random() < 0.15) {
      stock--;
      localStorage.setItem(stockKey, stock);
      updateStockEls();
    }
  }, 45000);

  /* exit intent handled in theme.liquid */

  /* ── UPSELL POPUP ── */
  showUpsellPopup = function(singleVid, qty, btn, orig) {
    var overlay = document.getElementById('kvUpsellOverlay');
    if (!overlay) {
      if (btn) { btn.innerHTML = '<span>Añadiendo...</span>'; btn.disabled = true; }
      addToCart(singleVid, qty, btn, orig);
      return;
    }
    overlay.style.display = 'flex';
    if (window.kvMarkPopup) window.kvMarkPopup();

    function closeUp() {
      overlay.style.display = 'none';
      if (btn) { btn.innerHTML = orig; btn.disabled = false; }
    }
    function addSingle() {
      overlay.style.display = 'none';
      if (btn) { btn.innerHTML = '<span>Añadiendo...</span>'; btn.disabled = true; }
      addToCart(singleVid, qty, btn, orig);
    }
    function addPack3() {
      overlay.style.display = 'none';
      if (btn) { btn.innerHTML = '<span>Añadiendo...</span>'; btn.disabled = true; }
      addToCart('57524808974680', 1, btn, orig); // pack de 3
    }

    var yesBtn = document.getElementById('kvUpsellYes');
    var noBtn  = document.getElementById('kvUpsellNo');
    var closeBtn = document.getElementById('kvUpsellClose');
    if (yesBtn)   yesBtn.onclick   = addPack3;
    if (noBtn)    noBtn.onclick    = addSingle;
    if (closeBtn) closeBtn.onclick = closeUp;
    overlay.onclick = function(e) { if (e.target === overlay) closeUp(); };
  };

  /* ── EMAIL POPUP ── */
  (function() {
    if (localStorage.getItem('kv_email_captured')) return;
    var popup = document.getElementById('kvEmailPopup');
    if (!popup) return;
    var shown = false;

    function showEmailPopup() {
      if (shown || localStorage.getItem('kv_email_captured')) return;
      var gap = window.KV_POPUP_GAP || 60000;
      // No solapar con otro popup: respetar 60s de separación
      if (window.kvAnyPopupOpen && window.kvAnyPopupOpen()) { setTimeout(showEmailPopup, 5000); return; }
      var since = window.kvSincePopup ? window.kvSincePopup() : Infinity;
      if (since < gap) { setTimeout(showEmailPopup, gap - since); return; }
      shown = true;
      if (window.kvMarkPopup) window.kvMarkPopup();
      popup.style.display = 'flex';
    }

    setTimeout(showEmailPopup, 45000);
    window.addEventListener('scroll', function() {
      var pct = window.scrollY / Math.max(1, document.body.scrollHeight - window.innerHeight);
      if (pct > 0.75 && !document.getElementById('kvExitPopup')?.style.display !== 'none') showEmailPopup();
    }, { passive: true });

    var closeBtn  = document.getElementById('kvEmailClose');
    var submitBtn = document.getElementById('kvEmailSubmit');
    var input     = document.getElementById('kvEmailInput');

    function dismissEmail() {
      popup.style.display = 'none';
      localStorage.setItem('kv_email_captured', '1');
    }

    if (closeBtn) closeBtn.onclick = dismissEmail;
    popup.onclick = function(e) { if (e.target === popup) dismissEmail(); };

    if (submitBtn) submitBtn.onclick = function() {
      var email = input ? input.value.trim() : '';
      if (!email || !email.includes('@')) {
        if (input) { input.style.borderColor = '#ef4444'; input.focus(); }
        return;
      }
      submitBtn.textContent = 'Enviando...';
      submitBtn.disabled = true;
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' + encodeURIComponent(email) + '&contact%5Btags%5D=newsletter'
      }).finally(function() {
        var inner   = document.getElementById('kvEmailFormInner');
        var success = document.getElementById('kvEmailSuccess');
        if (inner)   inner.style.display   = 'none';
        if (success) success.style.display = 'block';
        localStorage.setItem('kv_email_captured', '1');
        setTimeout(function() { popup.style.display = 'none'; }, 2500);
      });
    };
  })();

  /* ── BUNDLE SELECTOR ── */
  (function() {
    var bOpts = document.querySelectorAll('.kv-bopt');
    if (!bOpts.length) return;
    var bundleNote = document.getElementById('kvBundleNote');

    var PACK_COLORS = ['Negro', 'Gris', 'Beige', 'Azul marino', 'Blanco'];
    function buildPackColors(count) {
      var wrap = document.getElementById('kvPackColors');
      if (!wrap) return;
      wrap.innerHTML = '';
      for (var i = 1; i <= count; i++) {
        var row = document.createElement('div');
        row.className = 'kv-pack-color-row';
        var lbl = document.createElement('span');
        lbl.className = 'kv-pack-color-lbl';
        lbl.textContent = 'Gorra ' + i;
        var sel = document.createElement('select');
        sel.className = 'kv-pack-color-sel';
        sel.setAttribute('data-prop', 'Color gorra ' + i);
        PACK_COLORS.forEach(function (c) {
          var o = document.createElement('option');
          o.value = c; o.textContent = c; sel.appendChild(o);
        });
        sel.selectedIndex = (i - 1) % PACK_COLORS.length;
        row.appendChild(lbl); row.appendChild(sel); wrap.appendChild(row);
      }
    }

    bOpts.forEach(function(opt) {
      opt.addEventListener('click', function() {
        bOpts.forEach(function(o) { o.classList.remove('kv-bopt-active'); });
        opt.classList.add('kv-bopt-active');
        var vid = opt.dataset.vid;
        var type = opt.dataset.type;
        var btnLabel = opt.dataset.btn;

        // Actualizar todos los inputs de variant en la página
        ['variantId','kvVariantId'].forEach(function(id) {
          var el = document.getElementById(id);
          if (el) el.value = vid;
        });

        // Actualizar texto del botón ATC
        var atcBtns = document.querySelectorAll('.product-atc-btn, #kvAtcBtn');
        atcBtns.forEach(function(btn) {
          if (btnLabel) btn.textContent = '🛒 ' + btnLabel;
        });

        // Mostrar/ocultar selector de color y nota de bundle
        var kvVariantWrap = document.querySelector('.kv-variant-wrap');
        var colorSection = document.querySelector('.product-color-swatches');
        var colorLabel = document.querySelector('.product-variant-label');
        if (type === 'bundle') {
          if (kvVariantWrap) kvVariantWrap.style.opacity = '0.4';
          if (colorSection) colorSection.style.opacity = '0.4';
          if (colorLabel) colorLabel.style.opacity = '0.4';
          buildPackColors(parseInt(opt.dataset.count || '2', 10));
          if (bundleNote) bundleNote.style.display = 'block';
        } else {
          if (kvVariantWrap) kvVariantWrap.style.opacity = '1';
          if (colorSection) colorSection.style.opacity = '1';
          if (colorLabel) colorLabel.style.opacity = '1';
          if (bundleNote) bundleNote.style.display = 'none';
        }
      });
    });

    // Cuando cambia el color, actualizar el data-vid del pack ×1
    document.querySelectorAll('.product-swatch, .kv-swatch').forEach(function(sw) {
      sw.addEventListener('click', function() {
        var singleOpt = document.querySelector('.kv-bopt[data-type="single"]');
        if (!singleOpt) return;
        var newVid = this.getAttribute('data-variant-id') || this.dataset.variantId;
        if (!newVid) return;
        singleOpt.setAttribute('data-vid', newVid);
        if (singleOpt.classList.contains('kv-bopt-active')) {
          ['variantId','kvVariantId'].forEach(function(id) {
            var el = document.getElementById(id);
            if (el) el.value = newVid;
          });
        }
      });
    });

    // Init: si el pack activo por defecto es un bundle, construir sus desplegables
    var activeBundle = document.querySelector('.kv-bopt[data-type="bundle"].kv-bopt-active');
    if (activeBundle) {
      buildPackColors(parseInt(activeBundle.dataset.count || '2', 10));
      if (bundleNote) bundleNote.style.display = 'block';
    }
  })();

  /* ── STICKY BUY BAR — aparece al pasar el hero ── */
  (function() {
    var bar = document.getElementById('kvStickyBar');
    if (!bar) return;
    var hero = document.querySelector('.kv-hero');
    function updateSticky() {
      if (!hero) { bar.classList.add('kv-sticky-visible'); return; }
      var heroBottom = hero.getBoundingClientRect().bottom;
      if (heroBottom < 0) {
        bar.classList.add('kv-sticky-visible');
      } else {
        bar.classList.remove('kv-sticky-visible');
      }
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
  })();

  /* ── INIT ── */
  fetchCart();

})();
